import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Link from "@components/Theme/Link/Link"
import {BadgesModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./BadgesCard.module.scss"

type Props = {data: BadgesModuleType; className?: string}

const BadgesCard = (props: Props) => {
	return (
		<>
			{typeof props.data.link === "string" && (
				<Link
					className={`${styles.cardLinkWrapper} ${props.className}`}
					link={props.data.link}
				>
					<NewResponsiveImage
						{...props.data.preview}
						containerClassName={styles.cardBox}
						imageClassName={styles.badge}
						alt={props.data.title}
					/>
				</Link>
			)}
			{typeof props.data.link !== "string" && (
				<div
					className={`${styles.cardLinkWrapper} ${styles.notLink} ${props.className}`}
					style={{cursor: "default"}}
				>
					<NewResponsiveImage
						{...props.data.preview}
						containerClassName={styles.cardBox}
						imageClassName={styles.badge}
						alt={props.data.title}
					/>
				</div>
			)}
		</>
	)
}

export default BadgesCard
